import { HTTP } from '../../http-common'

export default {
  state: {
    loadedReadings2: []
  },
  getters: {
    loadedReadings2 (state) {
      return state.loadedReadings2
    }
  },
  mutations: {
    setLoadedReadings2 (state, payload) {
      state.loadedReadings2 = payload
    },
    clearLoadedReadings2 (state) {
      state.loadedReadings2 = []
    }
  },
  actions: {
    loadReadings2 ({ commit }, payload) {
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadedReadings2', [])
      console.log('loadReadings2')
      let endpoint = 'reading.json/'
      if (payload) {
        endpoint += '?' + payload // example: reading.json/page=4
      }
      return new Promise((resolve, reject) => {
        HTTP.get(endpoint)
          .then(result => {
            console.log(result.data)
            commit('setLoadedReadings2', result.data.results)
            resolve(result.data)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    clearLoadedReadings2 ({ commit }) {
      commit('clearLoadedReadings2')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/reading2/index.js